<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70" style="padding: 0px;">
  <div class="col-md-6 mt-6 mx-auto">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td class="v-align-m">Product ID</td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="selectedproductId"
              placeholder=""
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product Id</th>
          <th scope="col">Is a Derivative Product</th>
          <th scope="col">Product ID of Source Product</th>
          <th scope="col">Attributed Percentage</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>true</td>
          <td>{{product.source_product}}</td>
          <td>{{product.attributed_percentage}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
